export const loadGoogleMapsScript = (callback: () => void): void => {
  if (window.google?.maps) {
    callback();
    return;
  }

  const GOOGLE_MAPS_SCRIPT_ID = 'google-maps-script';
  if (document.getElementById(GOOGLE_MAPS_SCRIPT_ID)) {
    return;
  }

  const scriptElement = document.createElement('script');
  scriptElement.id = GOOGLE_MAPS_SCRIPT_ID;
  scriptElement.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCPZ_gY1GPpyMsXyGmCVwCAUbhsheU6wZQ&libraries=marker&v=beta&map_ids=DEMO_MAP_ID`;
  scriptElement.defer = true;

  // Copy nonce from an existing script if available (for CSP)
  const existingScript = document.querySelector('script[nonce]') as HTMLScriptElement;
  if (existingScript?.nonce) {
    scriptElement.nonce = existingScript.nonce;
  }

  scriptElement.onload = () => {
    if (window.google && window.google.maps && window.google.maps.marker) {
      callback();
    }
  };

  scriptElement.onerror = () => {
    if (document.getElementById(GOOGLE_MAPS_SCRIPT_ID)) {
      document.getElementById(GOOGLE_MAPS_SCRIPT_ID)?.remove();
    }
  };

  document.head.appendChild(scriptElement);
};
